import { Injectable } from '@angular/core';
import { Name } from '../core-data-model/Name';
import { User, UserUpdate } from '../core-data-model/User.model';
import {
    UserCreateAccountProvisioningServer,
    UserCreateServer,
    UserInfoServer,
    UserUpdateServer
} from '../core-data-model/UserApi.serverinterface';
import { UserFactory } from '../object-factory/User.factory';
import { InitDataService } from '../system-services/InitData/InitData.service';

@Injectable({
    providedIn: 'root'
})
export class UserV4Transformer {
    constructor(
        private initData: InitDataService,
        private userFactory: UserFactory
    ) {}

    userInfoServerToClient(userServer: UserInfoServer): User {
        return this.userFactory.new_User({
            firstName: userServer.firstName,
            middleName: userServer.middleName,
            lastName: userServer.lastName,
            email: userServer.email,
            role: userServer.userRole,
            phone: userServer.phone,
            jobTitle: userServer.jobTitle,
            defaultLanguage: userServer.defaultLanguage,
            defaultFolderId: userServer.defaultFolderId,
            hasCognitiveAccess: userServer.canAccessCognitive,
            accessEnabled: userServer.isEnabled,
            id: userServer.userId,
            lastLoginTime: userServer.lastLoginTime,
            personId: userServer.personId
        });
    }

    updateClientToServer(userUpdate: UserUpdate): UserUpdateServer {
        return {
            firstName: userUpdate.firstName,
            middleName: userUpdate.middleName,
            lastName: userUpdate.lastName,
            email: userUpdate.email,
            userRole: userUpdate.role,
            phone: userUpdate.phone,
            jobTitle: userUpdate.jobTitle,
            defaultLanguage: userUpdate.defaultLanguage,
            canAccessCognitive: userUpdate.hasCognitiveAccess,
            defaultFolderId: userUpdate.defaultFolderId,
            isEnabled: userUpdate.accessEnabled,
            userId: userUpdate.originalUser.id
        };
    }

    createClientToServer(userCreate: UserUpdate): UserCreateServer {
        return {
            firstName: userCreate.firstName,
            middleName: userCreate.middleName,
            lastName: userCreate.lastName,
            email: userCreate.email,
            jobTitle: userCreate.jobTitle,
            userRole: userCreate.role,
            phone: userCreate.phone,
            defaultLanguage: userCreate.defaultLanguage,
            canAccessCognitive: userCreate.hasCognitiveAccess,
            defaultFolderId: userCreate.defaultFolderId
        };
    }

    createClientToAccountProvisioningServer(
        userCreate: UserUpdate
    ): UserCreateAccountProvisioningServer {
        return {
            name: new Name({
                first: userCreate.firstName,
                last: userCreate.lastName,
                middle: userCreate.middleName
            }),
            email: userCreate.email,
            jobTitle: userCreate.jobTitle,
            userRole: userCreate.role,
            phone: userCreate.phone,
            defaultLanguage: userCreate.defaultLanguage,
            canAccessCognitive: userCreate.hasCognitiveAccess,
            defaultFolderId: userCreate.defaultFolderId,
            apiCompanyId: this.initData.account.currentApiCompanyId,
            teamId: userCreate.teamId,
            accountProvisionTriggerSubsource:
                userCreate.accountProvisionTriggerSubsource,
            product: userCreate.product
        };
    }
}
